<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>兑换码>新建兑换码</div>
		<div class="newADcontent">
			<div class="adContent">
				<p style="font-size: 14px;margin-top: 10px;"><span
						style="color: red;">*</span>提示：创建成功后，只能修改发行量和商品范围，且发行量和商品范围只能增加，不能减少</p>
				<div class="title" style="margin-top: 20px;">
					<div class="blue"></div>
					<div style="flex: 1;">基本设置</div>
				</div>
				<el-form ref="form" :model="addDataList" label-width="150px" label-position="left">
					<el-form-item label="兑换码名称">
						<el-input v-model="addDataList.name" style="width: 300px;" maxlength="12" show-word-limit
							size="small" placeholder="  输入兑换码名称，不能超过12个字"></el-input>
					</el-form-item>
					<el-form-item label="库存">
						<el-input-number v-model="addDataList.total" style="width: 300px;display: inline-block;"
							:min="1" :max="10000"></el-input-number>
						<span style="color: #999;font-size: 14px;margin-left: 20px;">兑换码库存不能大于兑换目标数量</span>
					</el-form-item>
					<el-form-item label="活动时间">
						<el-date-picker size="small" v-model="addDataList.time" type="datetimerange"
							format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<div class="title" style="margin-top: 20px;">
						<div class="blue"></div>
						<div style="flex: 1;">兑换权益</div>
					</div>
					<!-- <el-form-item label="兑换商品">
				    <el-button type="text" style="color: #999;"><i class="el-icon-plus"></i>添加商品</el-button>
				  </el-form-item> -->
					<el-form-item label="兑换优惠券">
						<el-tag v-if="coupon" style="height:80px;">
							<div>劵：{{ coupon.title }}</div>
							<div>库存：{{ coupon.totalNum-coupon.getNum }}张</div>

							<!-- 							<div v-if="coupon.sameDay!=''">{{coupon.dateType}}有效期：{{ coupon.startTime.substring(0, 16) }}至{{ coupon.endTime.substring(0, 16) }}</div>
							<div v-else>有效期：{{coupon.sameDay}}</div> -->
						</el-tag>
						<el-button type="text" style="color:#999; border:2px dashed; width:100px; margin-left:20px"
							@click="couponDislog=true; getCoupons()">
							<i class="el-icon-plus"></i>选择券
						</el-button>
					</el-form-item>
					<!-- <div class="title" style="margin-top: 20px;">
					<div class="blue"></div>
					<div style="flex: 1;">领取规则</div>
				  </div>
				  <el-form-item label="领取次数限制">
					<el-radio v-model="addDataList.countState" label="1">不限次数</el-radio>
					<p>
						<el-radio v-model="addDataList.countState" label="2">每人限领取
						<el-select style="width: 100px;margin:0 20px;" size="small" v-model="addDataList.count">
							<el-option
								v-for="item in addDataList.countList"
								:key="item"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
						次</el-radio>
					</p>
				  </el-form-item>
				  <el-form-item label="活动叠加限制">
				  	<el-checkbox v-model="addDataList.diejia">优惠券仅原价购买商品时可用，不可与其他营销活动叠加使用</el-checkbox>
				  </el-form-item> -->
					<el-form-item>
						<el-button @click="$router.push('/exchangeCode')">取消</el-button>
						<el-button type="primary" style="margin-left: 20px;" @click="addCodePlan">保存</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-dialog title="添加劵/劵包" :visible.sync="couponDislog" width="1200px" center>
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="couponFilter.name"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getCoupons">搜索</el-button>
				</el-form-item>
			</el-form>
			<el-tabs type="card" v-model="couponTable">
				<el-tab-pane label="劵" name="1">
					<el-table :data="coupons" height="400px">
						<el-table-column label="选择" width="50px" align="center">
							<template slot-scope="scope">
								<div style="width:20px; margin-left:10px; overflow:hidden;">
									<el-radio v-model="coupon" :label="scope.row"></el-radio>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="title" label="名称" align="center">
							<template slot-scope="scope">
								{{ scope.row.title }}
							</template>
						</el-table-column>
						<el-table-column prop="couponType" label="类型" align="center" width="80px">
							<template slot-scope="scope">
								{{ scope.row.couponType }}
							</template>
						</el-table-column>
						<el-table-column prop="storeNames" label="适用范围" align="center" width="250px">
							<template slot-scope="scope">
								{{ scope.row.storeNames | storeNameFilter }}
							</template>
						</el-table-column>
						<el-table-column prop="content" label="劵内容" align="center">
							<template slot-scope="scope">
								{{ scope.row.content }}
							</template>
						</el-table-column>
						<el-table-column label="有效期" align="center" width="180px">
							<template slot-scope="scope">
								<div v-if="scope.row.dateType==0">
									<span v-if="scope.row.startTime && scope.row.endTime">
										{{ scope.row.startTime.substring(0, 16) }}至{{ scope.row.endTime.substring(0, 16) }}
									</span>
									<span v-else>/</span>
								</div>
								<div v-else>
									领取后{{scope.row.sameDay}}天后到期
								</div>
							</template>
						</el-table-column>
						<el-table-column label="已领取/总数" align="center" width="100px">
							<template slot-scope="scope">
								{{ scope.row.getNum }}/{{ scope.row.totalNum }}
							</template>
						</el-table-column>
					</el-table>
					<el-pagination background @current-change="couponsPage" layout="prev, pager, next"
						:current-page="couponFilter.pageNum" :page-size="couponFilter.pageSize"
						:total="couponFilter.total">
					</el-pagination>
				</el-tab-pane>
				<el-tab-pane label="劵包" name="2">
				</el-tab-pane>
			</el-tabs>
			<div style="position: relative; left: 980px">
				<el-button @click="couponDislog=false,couponId=undefined">取消</el-button>
				<el-button type="primary" @click="submit()">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				couponTable: "1",
				couponDislog: false,
				coupon: undefined,
				addDataList: {
					name: undefined,
					total: 1,
					time: undefined,
					startTime: undefined,
					endTime: undefined,
					targetId: undefined
					// count:"",
					// countState:"",
					// countList:[1, 2, 3],
					// diejia:false
				},
				coupons: [],
				couponFilter: {
					name: undefined,
					pageNum: 1,
					pageSize: 10,
					total: 0,
				},
			}
		},
		filters: {
			storeNameFilter(data) {
				if (data) {
					return [...data].toString();
				}
				return "/";
			},
		},
		methods: {
			addCodePlan() {
				if (this.addDataList.time == null) return this.$message.warning("请选择时间")
				let time = this.addDataList.time
				// if(!time) return this.$message.warning("请选择时间")
				if (time[0] === time[1]) return this.$message.warning("请选择合理的时间范围")
				this.addDataList.startTime = time[0];
				this.addDataList.endTime = time[1];
				this.addDataList.targetId = this.coupon.id
				this.addDataList.time = undefined
				this.$http.post("codePlan/edit", JSON.stringify(this.addDataList)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.$router.push("/exchangeCode")
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			couponsPage(val) {
				this.couponFilter.pageNum = val;
				this.getCoupons()
			},
			getCoupons() {
				var date = new Date().toString().slice(11, 24)
				let url = "pageNum=" + this.couponFilter.pageNum + "&pageSize=" + this.couponFilter.pageSize
				if (this.couponFilter.name) url += "&name=" + this.couponFilter.name
				this.$http.get("dCoupon/list?" + url).then(res => {
					this.coupons = res.body.data;
					this.coupons.forEach(coupon => {
						if (coupon.dateType == 1) {
							coupon.startTime = date
							coupon.endTime = date
						}
					})
					this.couponFilter.total = res.body.total;
				})
			},
			submit() {
				this.couponDislog = false
			}
		},
	}
</script>

<style lang="less" scoped>
	p {
		margin: 0;
		padding: 0;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			img {
				width: 300px;
				height: auto;
			}
		}
	}
</style>